"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWaitingRoom = exports.WaitingRoom = exports.defaultWaitingRoomText = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var provider_1 = require("../../provider");
var shared_1 = require("../shared");
var hooks_1 = require("../../hooks");
exports.defaultWaitingRoomText = {
    sorry: "We\u2019re sorry",
    errorMessage: "Our site is currently experiencing heavy traffic.",
    message: "You are in the waiting queue. Our team is working diligently to serve each user one by one. Thank you for your patience.",
    backSoon: "We will be fully back soon",
};
var WaitingRoom = function (_a) {
    var isLoading = _a.isLoading, _b = _a.text, text = _b === void 0 ? exports.defaultWaitingRoomText : _b;
    var showError = (0, exports.useWaitingRoom)(isLoading).showError;
    var WaitingRoomErrorComponent = (0, hooks_1.useGraceful)().WaitingRoomErrorComponent;
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: showError
            ? WaitingRoomErrorComponent || (0, jsx_runtime_1.jsx)(shared_1.SharedError, { text: text })
            : null }));
};
exports.WaitingRoom = WaitingRoom;
var useWaitingRoom = function (isLoading) {
    var _a = (0, react_1.useState)(false), showError = _a[0], setShowError = _a[1];
    (0, react_1.useEffect)(function () {
        if (!isLoading) {
            setShowError(false);
            return;
        }
        var timeout = setTimeout(function () {
            setShowError(true);
        }, provider_1.maxRequestResolveTime * 1000);
        return function () {
            clearTimeout(timeout);
        };
    }, [isLoading]);
    return { showError: showError };
};
exports.useWaitingRoom = useWaitingRoom;
